<template>
    <div class="cs4-cart__item" :class="[{'cs4-cart__item--deleteStep': isDeletingStep}]" v-if="shouldItemBeShown()">
      <div class="cs4-cart__itemContainer" :class="{'cs4-cart__itemContainer--expandable': cartItemInfo.length > 1}">
        <div class="cs4-cart__itemTitle">{{ getCartItemName()}}</div>
        <div class="cs4-cart__itemDelete" v-on:click="onDeleteClick()">
          <img class="cs4-cart__itemDeleteIcon" src="https://comprasocial.me/wp-content/uploads/2022/10/icon-cross-bold-red.svg" alt="icon remove close">
        </div>
        <div class="cs4-cart__itemInfoLabel">{{dictionary.links}}:</div>
        <div class="cs4-cart__itemInfo" :class="[{'cs4-cart__itemInfo--expanded': isCartItemExpanded }]">
          <div v-for="(singleLink) in cartItemInfo" :key="singleLink" class="cs4-cart__itemInfoContainer">
            <div class="cs4-cart__itemInfoTextContainer" >
              <span :class="[{'cs4-cart__itemInfoLI': shouldItemInfoSlide(singleLink)}]">{{singleLink}}</span>
            </div>
          </div>
        </div>
        <div class="cs4-cart__itemPrice" :class="{'cs4-cart__itemPrice--bottom': isCartItemExpanded}">{{getCartItemPrice()}}</div>
        <div class="cs4-cart__itemDeleteStep" :class="{'cs4-cart__itemDeleteStep--active': isDeletingStep }">
          <div class="cs4-cart__itemDeleteTitle"> {{dictionary.areYouSureThatYouWantToDeleteIt}}  </div>
          <div class="cs4-cart__itemDeleteButtonContainer">
            <div class="cs4-cart__itemDeleteButton cs4-cart__itemDeleteButton--active" v-on:click="onDeleteCancel()">{{dictionary.noKeepIt}}</div>
            <div class="cs4-cart__itemDeleteButton" v-on:click="onDeleteConfirm()">{{dictionary.yesDeleteIt}}</div>
          </div>
        </div>
    </div>
    <div class="cs4-cart__itemExpander" v-if="cartItemInfo.length > 1" v-on:click="toggleCartItemExpanded()">
          <span class="cs4-cart__itemExpanderArrow" :class="[{ 'cs4-cart__itemExpanderArrow--down': isCartItemExpanded}]"></span>
        </div>
    </div>
</template>

<script>
    export default {
        props: [ "currentItem",'dictionary', 'bonusOfferKey'],
        emits: ['deleteCartItem'],
        data(){
            return {
              isCartItemExpanded: false,
              cartItemInfo: [],
              isDeletingStep: false
            }
        },
        methods: {
            shouldItemBeShown(){
                return this.currentItem.key != this.bonusOfferKey;
            },
            getCartItemName(){
                return this.currentItem.name.replace("&#8211;","-");
            },
            getCartItemInfo (){
                return this.currentItem.item_data.find(cItem => {
                    return cItem.key === "Links";
                }).value.split(',');
            },
            getCartItemPrice(currency = "EUR") {
                const formatter = new Intl.NumberFormat('it-IT', {
                    style: 'currency',
                    currency: currency
                });
                return formatter.format(this.currentItem.totals.line_total/100);
            },
            shouldShowItemExpander(){
                const itemInfo = this.getCartItemInfo;
                return itemInfo.length > 1;
            },
            shouldItemInfoSlide(itemInfo){
                return itemInfo.length > 32;
            },
            toggleCartItemExpanded(){
              this.isCartItemExpanded = !this.isCartItemExpanded;
            },
            onDeleteClick(){
              this.isDeletingStep = !this.isDeletingStep;
            },
            onDeleteConfirm(){
              this.$emit('deleteCartItem', this.currentItem.key)
            },
            onDeleteCancel(){
              this.isDeletingStep = !this.isDeletingStep;
            }
        },
        created() {
          if(this.shouldItemBeShown()){
            this.cartItemInfo = this.getCartItemInfo();
          }
        }
        
    }
</script>

<style lang="scss" scoped>
.cs4-cart__item {
    position: relative;
    &Container{
      background-color: #FFFFFF;
      border-radius: 25px;
      text-align: left;
      padding: 10px 15px;
      margin-bottom: 10px;
      display: grid;
      grid-template-columns: 1fr 0.3fr;
      position: relative;
      z-index: 202;
      transition: background-color .5s;
      min-height: 90px;

      &--expandable {
        margin-bottom: 25px;
      }
    }

    &Delete {
      &Step{
        height: 0;
        overflow: hidden;
        &--active{
          height: 100%;
        }
      }
      &Title,&Button{
        opacity: 0;
        transition: opacity .5s;
      }
    }

    
    &--deleteStep {
      .cs4-cart__item{
        overflow: hidden;

        &Delete {
          &Step {
            display: grid;
            grid-row: 1 / span 2;
            grid-column: 1/span 2;
            grid-template-rows: 1fr 1fr;
            grid-template-columns: 1fr;
            opacity: 1;
          }

          &Title{
            font-size: 15px;
            font-weight: 500;
            grid-column: 1 / span 2;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          &Button{
            color: white;
            background: #FB7283;
            border: 3px solid #FFFFFF;
            border-radius: 25px;
            width: 120px;
            height: 25px;
            text-align: center;
            font-weight: 500;
            font-size: 14px;
            cursor: pointer;

            &--active{
              color: #FB7283;
              background: white;
              font-weight: 600;
            }

            &Container{
              display: flex;
              align-items: center;
              justify-content: space-around;
              margin: 0 25px;
            }
          }

          &Title,&Button{
            opacity: 1;
            transition: opacity .5s;
            transition-delay: .5s;
          } 
        }

        &Container {
          background-color: #FB7283;
          transition: background-color .5s;
          transition-delay: .5s;
        }
        &DeleteIcon{
          border-color: #fff;
          filter: brightness(0) invert(1);
        }

        &Expander {
          bottom: 0;
          transition: bottom .5s;

          &Arrow {
            border-color: white;
            transition: border-color 0.2s;
          }
        }

        &Title,&InfoLabel,&Info,&Price{
          opacity: 0;
          visibility: hidden;
          display: none;
          transition: opacity .5s, visibility .5s, display .01s;
          transition-delay: 0, .5s,.5s;
        }
      }
    }

    &Title,&InfoLabel,&Info,&Price{
      opacity: 1;
      visibility: visible;
      transition: opacity .5s, visibility .5s;
      transition-delay: .5s, .5s;
    }

    &Title {
      font-size: 15px;
      font-weight: 600;
      color:#1B6487;
      grid-row: 1;
      grid-column: 1;
    }

    &Delete {
      grid-row: 1;
      grid-column: 2;
      display: flex;
      justify-content: right;
      justify-self: end;
      
      &Icon{
       width: 23px;
       height: 23px;
       padding: 2.2px;
       border: 3px solid #FB7283;
       border-radius: 100%;
       cursor: pointer;
      }
    }

    &Info {
      font-size: 12px;
      font-weight: 400;
      color:#8D47D0;
      grid-column: 1;
      max-width: 230px;
      max-height: 30px;
      padding-bottom: 0;
      transition: max-height 1s, padding-bottom 1s;
      overflow: hidden;

      &--expanded {
        max-height: 400px;
        padding-bottom: 25px;
        transition: max-height 2s, padding-bottom 2s;
        transition-delay: 0, 2s;
      }

      &Container {
        display: flex;
        overflow: hidden;
        align-items: center;
        margin-top: 5px;
        white-space: nowrap;
      }

      &Container::before {
        content: '';
        color: #1B6487;
        font-size: 28px;
        width: 0px;
        height: 0px;
        border: 3px solid #1B6487;
        border-radius: 100%;
        display: block;
      }

      &LI {
        animation-name: scrollingText;
        animation-duration: 5s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        animation-direction: alternate;
        display: flex;
        align-items: center;
      }

      &Label {
        font-size: 12px;
        font-weight: 400;
        color:#636363;
        grid-column: 1;
      }

      &TextContainer{
        overflow: hidden;
        margin-left: 5px;
        display: flex;
      }
    }

    &Price {
      font-size: 18px;
      font-weight: 700;
      color:#1B6487;
      grid-column: 2;
      grid-row: 3;
      display: flex;
      justify-content: right;
      margin-left: 15px;
      align-items: flex-end;
    }

    &Expander{
      display: flex;
      background: white;
      width: 35px;
      height: 25px;
      position: absolute;
      bottom: -20px;
      left: 0;
      right:0;
      margin-left: auto; 
      margin-right: auto; 
      justify-content: center;
      border-radius: 0 0 15px 15px;
      cursor: pointer;
      z-index: 200;
      transition: bottom .5s;
      &Arrow {
        width:9px;
        height: 9px;
        display: block;
        border-width: 3px 3px 0 0;
        border-style: solid;
        border-color: #1B6487;
        transform: rotate(-225deg);
        margin-top:5px;
        transition: margin-top 1s, transform 1s;

        &--down {
          transform: rotate(-45deg);
          margin-top: 10px;
          transition: margin-top 1s, transform 1s;
        }
      }
    }
  }


  @keyframes scrollingText {
    0% {
      transform: translateX(0);
    }
    10% {
      transform: translateX(0);
    }
    90% {
      transform: translateX(-30%);
    }
    100%{
      transform: translateX(-30%);
    }
  }
</style>